import { render, staticRenderFns } from "./BusinessMemberHistoryCommentEvent.vue?vue&type=template&id=480dfd84"
import script from "./BusinessMemberHistoryCommentEvent.vue?vue&type=script&lang=js"
export * from "./BusinessMemberHistoryCommentEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports